// ?country=<id> — venir de l'annuaire du dashboard et trouver le pays cadré.
//
// L'emprise se calcule sur la géométrie des régions du pays, pas sur leurs
// centroïdes : un pays d'une seule grande région aurait sinon une emprise
// nulle, et la carte zoomerait au maximum sur un point.

function visit(coordinates, bounds) {
  if (!Array.isArray(coordinates)) return
  if (typeof coordinates[0] === 'number' && typeof coordinates[1] === 'number') {
    const [lng, lat] = coordinates
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return
    bounds[0] = Math.min(bounds[0], lng)
    bounds[1] = Math.min(bounds[1], lat)
    bounds[2] = Math.max(bounds[2], lng)
    bounds[3] = Math.max(bounds[3], lat)
    return
  }
  for (const item of coordinates) visit(item, bounds)
}

/** [minLng, minLat, maxLng, maxLat] des régions du pays, ou null. */
export function countryBounds(regionsData, countryId) {
  const id = Number(countryId)
  if (!id || !regionsData || !Array.isArray(regionsData.features)) return null
  const bounds = [Infinity, Infinity, -Infinity, -Infinity]
  for (const feature of regionsData.features) {
    if (Number(feature?.properties?.country_id) !== id) continue
    visit(feature.geometry?.coordinates, bounds)
  }
  return Number.isFinite(bounds[0]) ? bounds : null
}

/** L'identifiant demandé par l'URL, ou null. */
export function requestedCountry(search) {
  const value = Number(new URLSearchParams(search || '').get('country'))
  return Number.isInteger(value) && value > 0 ? value : null
}
